import { Component } from '@angular/core';

@Component({
	selector: 'bcb-onboarding-home',
	templateUrl: './onboarding-home.component.html',
	styleUrls: ['./onboarding-home.component.scss'],
})
export class OnboardingHomeComponent {}
